/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './multi-editor-search.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../app/multi-editor/multi-editor-search/multi-editor-search.component';
import * as i4 from '@angular/common';
const styles_MultiEditorSearchComponent:any[] = [i0.styles];
export const RenderType_MultiEditorSearchComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MultiEditorSearchComponent,data:{}});
function View_MultiEditorSearchComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1,
      147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,[2,i2.SelectControlValueAccessor]],
      {ngValue:[0,'ngValue']},(null as any)),i1.ɵdid(2,147456,(null as any),0,i2.ɵq,
      [i1.ElementRef,i1.Renderer2,[8,(null as any)]],{ngValue:[0,'ngValue']},(null as any)),
      (_l()(),i1.ɵted(3,(null as any),[' ',' ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.name;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit.name;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = _v.context.$implicit.value;
    _ck(_v,3,0,currVal_2);
  });
}
export function View_MultiEditorSearchComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),9,'select',[['class',
      'form-control input-sm'],['name','collections']],[[2,'ng-untouched',(null as any)],
      [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
          (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
      [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
      'change'],[(null as any),'blur']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.MultiEditorSearchComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,1).onChange($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,1).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_2:any = ((<any>_co.onCollectionChange($event)) !== false);
      ad = (pd_2 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.SelectControlValueAccessor,
      [i1.Renderer2,i1.ElementRef],(null as any),(null as any)),i1.ɵprd(1024,(null as any),
      i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.SelectControlValueAccessor]),i1.ɵdid(3,671744,(null as any),0,i2.NgModel,
      [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
      {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
      i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(5,16384,(null as any),0,i2.NgControlStatus,
      [i2.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_MultiEditorSearchComponent_1)),i1.ɵdid(8,802816,(null as any),0,i4.NgForOf,
      [i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,'ngForOf']},
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,
      (null as any),['\n'])),(_l()(),i1.ɵeld(11,0,(null as any),(null as any),14,'div',
      [['class','input-group']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(13,
      0,(null as any),(null as any),5,'input',[['class','form-control input-sm'],['placeholder',
          'Search records'],['type','text']],[[2,'ng-untouched',(null as any)],[2,
          'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
          (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'keyup.enter'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
          'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.MultiEditorSearchComponent = _v.component;
        if (('input' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,14)._handleInput($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,14).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('compositionstart' === en)) {
          const pd_2:any = ((<any>i1.ɵnov(_v,14)._compositionStart()) !== false);
          ad = (pd_2 && ad);
        }
        if (('compositionend' === en)) {
          const pd_3:any = ((<any>i1.ɵnov(_v,14)._compositionEnd($event.target.value)) !== false);
          ad = (pd_3 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_4:any = ((<any>(_co.query = $event)) !== false);
          ad = (pd_4 && ad);
        }
        if (('keyup.enter' === en)) {
          const pd_5:any = ((<any>_co.onSearchClick(_co.query)) !== false);
          ad = (pd_5 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(14,16384,(null as any),0,i2.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i2.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i2.DefaultValueAccessor]),i1.ɵdid(16,671744,(null as any),0,i2.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i2.NgControl,(null as any),[i2.NgModel]),i1.ɵdid(18,16384,(null as any),
          0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(20,0,(null as any),(null as any),
          4,'span',[['class','input-group-btn']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(22,0,(null as any),(null as any),1,'button',[['class','btn btn-default search-button'],
          ['type','button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.MultiEditorSearchComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.onSearchClick(_co.query)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵeld(23,0,(null as any),(null as any),
          0,'i',[['aria-hidden','true'],['class','fa fa-search fa-3']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
          i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.MultiEditorSearchComponent = _v.component;
    const currVal_7:any = 'collections';
    const currVal_8:any = _co.selectedCollection;
    _ck(_v,3,0,currVal_7,currVal_8);
    const currVal_9:any = _co.collections;
    _ck(_v,8,0,currVal_9);
    const currVal_17:any = _co.query;
    _ck(_v,16,0,currVal_17);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,5).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,5).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,5).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,5).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,5).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,5).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,5).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_10:any = i1.ɵnov(_v,18).ngClassUntouched;
    const currVal_11:any = i1.ɵnov(_v,18).ngClassTouched;
    const currVal_12:any = i1.ɵnov(_v,18).ngClassPristine;
    const currVal_13:any = i1.ɵnov(_v,18).ngClassDirty;
    const currVal_14:any = i1.ɵnov(_v,18).ngClassValid;
    const currVal_15:any = i1.ɵnov(_v,18).ngClassInvalid;
    const currVal_16:any = i1.ɵnov(_v,18).ngClassPending;
    _ck(_v,13,0,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,
        currVal_16);
  });
}
export function View_MultiEditorSearchComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'re-multi-editor-search',
      ([] as any[]),(null as any),(null as any),(null as any),View_MultiEditorSearchComponent_0,
      RenderType_MultiEditorSearchComponent)),i1.ɵdid(1,49152,(null as any),0,i3.MultiEditorSearchComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const MultiEditorSearchComponentNgFactory:i1.ComponentFactory<i3.MultiEditorSearchComponent> = i1.ɵccf('re-multi-editor-search',
    i3.MultiEditorSearchComponent,View_MultiEditorSearchComponent_Host_0,{},{search:'search',
        collectionChange:'collectionChange'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/multi-editor-search/multi-editor-search.component.ngfactory.ts